import type { Release } from '../releases.ts';

export default {
  version: '0.25.0',
  date: '2026-10-08',
  title: 'Search and lists: all results, subtitles, saved searches and better pickers',
  summary: [
    'The Library shows every result, loading 100 at a time as you scroll',
    'Subtitles are searchable, with the matching lines in the results',
    'Saved searches keep the search, filters, sort and view under a name',
    'An Added filter: today, this week or this month',
    'Search sequences and workflows, and share collections with people by name',
    'Fixed: asset IDs are searched faster in large libraries',
  ],
  features: [
    'The Library shows every result: it loads 100 at a time as you scroll the grid or the table (the phone layout has Load more), and the toolbar says “Showing 300 of 12 431”',
    'Subtitles are searchable. Searching finds assets by what is said, results show the matching subtitle lines with the track, timecode and picture, clicking one opens the asset on its Subtitles tab at that line, and Advanced search has a Subtitles target',
    'Saved searches: Save search… in the Library toolbar keeps the search, filters, advanced search, sort and view under a name. They are listed at the top of the filter pane (open, rename, delete) and only you see them',
    'The Library filter has an Added group: Today, This week (from Monday) and This month, counted from when the media was ingested, in your time zone',
    'Create: search the sequence list by name and description, switch between All and My sequences, see each sequence’s owner, and write a description in the sequence editor (shown in the list)',
    'Workflows: search by name and filter by State (Enabled or Off) and Starts when',
    'Sharing a collection: type a name or email, pick one or more people from the suggestions, choose Can view or Can edit and Add; the people it is shared with are listed with a selector and Remove',
  ],
  fixes: [
    'Asset IDs are searched faster in large libraries, and the result count is no longer recounted for every page',
  ],
} satisfies Release;
